"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animation = exports.inputAdornment = void 0;

var _stylitas = require("@creditas/stylitas");

var _input = require("./input.style");

const inputAdornment = () => (0, _stylitas.css)`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 4px;

  & > div {
    ${_input.inputIconComponent};
  }
`;

exports.inputAdornment = inputAdornment;

const animation = () => (0, _stylitas.css)`
  ${_stylitas.utilities.animation.spin};
`;

exports.animation = animation;